import axios from 'axios';

const state = {
  settings: {} 
};

const mutations = {
  setSettings(state, settings) {
    state.settings = settings;
  },
};

const actions = {
  async fetchSettings({ commit }) {
    const userToken = localStorage.getItem('userToken'); 
    if (!userToken) {
      return null; // Handle no token case
    }

    const savedId = localStorage.getItem('userId');
    if (!savedId) {
      console.error('No user ID found in local storage.');
      return null; 
    }

    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      const response = await axios.get(`${baseUrl}/users/${savedId}/settings`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });

      console.log('API Response:', response.data);
  
      if (response.data) {
        
        commit('setSettings', response.data); 
        return response.data;
      } else {
        console.error('No settings found in API response.');
        return null; 
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
      throw error;
    }
  },

  async updateSettings({ commit }, settings) { 
    const userToken = localStorage.getItem('userToken');
    const savedId = localStorage.getItem('userId');

    if (!userToken || !savedId) {
      return; // Handle missing token or user ID
    }

    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      const response = await axios.put(`${baseUrl}/users/${savedId}/settings`, settings, {
        headers: { Authorization: `Bearer ${userToken}` }
      });

      console.log('Update Response:', response.data); // Log response
      return response.data; // Return update confirmation if needed
    } catch (error) {
      console.error('Error updating settings:', error);
      throw error; // Propagate error
    }
  },
};

// NEW: Added getters for consistency
const getters = {
  getSettings: (state) => state.settings,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters, // NEW
};